import { Button, Form, FormGroup, FormSelect, Col, Row } from "react-bootstrap"
import { MessageType, useMessageReport } from "../../components/MessageReporter"
import { useAuth0 } from "@auth0/auth0-react"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { ApiClient } from "../../ApiClient"
import { useApi } from "../../hooks/ApiProvider"

export const Tenants = [
    {
        name: "BEN",
        value: "BEN",
    },
    {
        name: "Inventum",
        value: "INVENTUM",
    },
    {
        name: "Joule",
        value: "JOULE",
    },
    {
        name: "Joule Technologies Development",
        value: "JT",
    },
]

export const MapTenantToTenantName = (tenant) => {
    return Tenants.find((x) => x.value === tenant)?.name
}

export const UserAdd = () => {
    const { addMessage } = useMessageReport()
    const { getAccessTokenSilently } = useAuth0()
    const navigate = useNavigate()

    const [role, setRole] = useState("SUPPORT")
    const [tenant, setTenant] = useState(Tenants[0].value)
    const [email, setEmail] = useState("")
    const [filteredRoles, setFilteredRoles] = useState([])

    const { managementApi } = useApi()

    useEffect(() => {
        managementApi
            .managementGetRoles()
            .then((roles) => roles.filter((r) => r.name !== "CONSUMER"))
            .then(setFilteredRoles)
            .catch((e) => {
                addMessage(
                    "Failed to load roles",
                    "Something went wrong while loading roles, see the console for more details.",
                    MessageType.error,
                    e
                )
            })
    }, [managementApi, setFilteredRoles, addMessage])

    const createUser = () => {
        const selectedRole = filteredRoles.filter((r) => r.name === role).pop()
        if (!selectedRole) {
            return
        }
        getAccessTokenSilently()
            .then((token) =>
                ApiClient.post(
                    "/v2/consumer/users/role",
                    {
                        email: email,
                        role: {
                            id: selectedRole.id,
                            name: selectedRole.name,
                        },
                        tenant: tenant,
                    },
                    {
                        Authorization: "Bearer " + token,
                    }
                )
            )
            .then(({ headers }) => navigate("/user/" + headers.location))
            .catch((err) => {
                addMessage(
                    "Failed to create user",
                    "Something went wrong while creating the user, " +
                        "see the console for more details.",
                    MessageType.error,
                    err
                )
            })
    }

    return (
        <Row className="content-section">
            <Col>
                <h2>User creation</h2>
                <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                        type="email"
                        onChange={(e) => {
                            setEmail(e.target.value)
                        }}
                    />
                </Form.Group>
                <FormGroup className="mb-3">
                    <Form.Label>Role</Form.Label>
                    <FormSelect
                        id="role-select"
                        value={role}
                        onChange={(e) => {
                            setRole(e.target.value)
                        }}
                    >
                        {filteredRoles.map((fRole) => (
                            <option key={fRole.name} value={fRole.name}>
                                {fRole.name?.toLowerCase()}
                            </option>
                        ))}
                    </FormSelect>
                </FormGroup>
                <FormGroup>
                    <Form.Label>Tenant</Form.Label>
                    <FormSelect
                        value={tenant}
                        onChange={(e) => {
                            setTenant(e.target.value)
                        }}
                    >
                        {Tenants.map((tenant) => (
                            <option key={tenant.value} value={tenant.value}>
                                {tenant.name}
                            </option>
                        ))}
                    </FormSelect>
                </FormGroup>
                <Button className="mt-4" onClick={createUser}>
                    Create
                </Button>
            </Col>
        </Row>
    )
}
